export {
  breadcrumbsContainer,
  grid,
  heading,
  largeSpacingBottom,
  maxWidthContainer,
  narrowColumn,
  overallRatingWrapper,
  partnerModules,
  partnerProductsCarousel,
  productReviewsWrapper,
  productTitle,
  spanAcrossRows,
  widerColumn,
  wrapper,
} from '../Standard/StandardLayout.styles';
